import { render, staticRenderFns } from "./saveEnterprisePracticeResource.vue?vue&type=template&id=22de2c10&"
import script from "./saveEnterprisePracticeResource.vue?vue&type=script&lang=js&"
export * from "./saveEnterprisePracticeResource.vue?vue&type=script&lang=js&"
import style0 from "./saveEnterprisePracticeResource.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports